import otpDirektLoginController from './otp-direkt-login-controller';

export default function (app) {
	app.component('otpDirektLogin', {
		transclude: true,
		bindings: {
			serviceNotAvailable: '=',
			direktForm: '=?',
			otpLogin: '=',
			hasNoOtpDirekt: '=',
			selectedCompanyName: '=',
			completeInvoiceNumberFunction: '&',
			otpDirektLoginFunction: '&',
			noOtpDirektFunction: '&',
			successCallback: '&',
			hideOtpDirektLogin: '&'
		},
		templateUrl: 'common/otp-direkt-login-onboarding',
		controller: ['$scope', 'pageContext', otpDirektLoginController]
	});
};
